


interface MerchIconProps {
	className?: string,
}


const MerchIcon = (props: MerchIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-merch-icon"
			className={`svg-inline--fa fa-custom-merch-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 457 512">
			<path fill="currentColor" d="m142.33,27.98c-35.18,18.79 -123.52,75.95 -142.11,186.28c-1.6,9.59 5.6,18.39 15.39,18.39c19.99,0 52.37,0 70.35,0c7.6,0 14.19,-5.6 15.19,-12.99c5.6,-36.18 22.79,-138.31 47.37,-185.28c2.2,-4 -2.2,-8.39 -6.2,-6.2l0,-0.2z"/>
			<path fill="currentColor" d="m314.62,27.98c35.18,18.79 123.52,75.95 142.11,186.08c1.6,9.59 -5.6,18.39 -15.39,18.39c-19.99,0 -52.37,0 -70.35,0c-7.6,0 -14.19,-5.6 -15.19,-12.99c-5.6,-36.18 -22.79,-138.31 -47.37,-185.28c-2.2,-4 2.2,-8.39 6.2,-6.2z"/>
			<path fill="currentColor" d="m142.53,232.65c-8.59,0 -15.39,-7.4 -14.79,-16.19c3.8,-52.77 21.79,-216.46 100.94,-216.46c74.55,0 95.74,163.1 100.54,216.06c0.8,8.79 -6,16.39 -14.79,16.39l-171.89,0l0,0.2z"/>
			<path fill="currentColor" d="m208.89,248.44l34.38,0c4.6,0 8.39,3.8 8.39,8.39l0,190.08c0,4.6 3.8,8.39 8.39,8.39l45.97,0c7.8,0 13.99,6.2 13.99,13.99l0,27.78c0,7.8 -6.2,13.99 -13.99,13.99l-159.1,0c-7.8,0 -13.99,-6.2 -13.99,-13.99l0,-27.58c0,-7.8 6.2,-13.99 13.99,-13.99l45.97,0c4.6,0 8.39,-3.8 8.39,-8.39l-0.6,-190.28c0,-4.6 3.8,-8.39 8.39,-8.39l-0.2,0z"/>
		</svg>
	);
};

export default MerchIcon;